import React, { useEffect, useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { 
  Col, 
  Container, 
  Row, 
  Form,
} from 'react-bootstrap';
import { Button, ButtonGroup } from '@/shared/components/Button';
import {
   Card, CardBody, CardTitleWrap, CardTitle, CardSubhead,
} from '@/shared/components/Card';
import { Table } from '@/shared/components/TableElements';
import Pagination from 'react-bootstrap/Pagination'; 
import { FaExclamationCircle } from 'react-icons/fa';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { Mealcontext } from '../../../../../context/MealContext';
import RequestShort from './RequestShort';
import ProgressBar from '../../../Loader';
import { AuthContext } from '../../../../../context/AuthContext';
import { SideBarRefreshContext } from '../../../../../context/SideBarRefreshContext';

const RequestList = () => {
  const [request, setRequest] = useState([]);
  const [filterRequest, setFilterRequest] = useState([]);
  const [isLoading, setIsLoading] = useState(true); 
  const [errors, setError] = useState(null); 
  const { refresh } = useContext(Mealcontext);
  const { apiGlobal, countryid } = useContext(AuthContext);
  const { sideBarRefresh } = useContext(SideBarRefreshContext);
  const [searchQuery, setSearchQuery] = useState('');
   const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 7;
  
// Pagination Logic - Slice data for the current page
const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;

const currentItems = filterRequest.slice(indexOfFirstItem, indexOfLastItem);
const totalPages = Math.ceil(filterRequest.length / itemsPerPage);

const pageNumbers = [];
const maxVisiblePages = 3;
const startPage = Math.max(1, currentPage - 1);
const endPage = Math.min(totalPages, currentPage + 1);

for (let i = startPage; i <= endPage; i += 1) {
  pageNumbers.push(i);
}

if (startPage > 1) {
  pageNumbers.unshift('...');
}

if (endPage < totalPages) {
  pageNumbers.push('...');
}

if (pageNumbers[pageNumbers.length - 1] !== totalPages) {
  pageNumbers.push(totalPages);
}


  const fetchData = async () => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append('country_id', countryid);
    try {
      const response = await fetch(`${apiGlobal}meal_pending_list.php`, {
        method: 'POST',
        body: formData,
      });
      const data = await response.json();
      if (data.status && data.message === 'Success') {
        setRequest(data.data);
        setFilterRequest(data.data);
        // console.log(data.data);
      } else {
        setRequest([]);
        setFilterRequest([]);
      }
    } catch (error) {
      setError('Failed to load data. Please try again later.');
    } finally {
      setIsLoading(false);
    }
  };
  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
  
    if (query) {
      const filteredData = request
      .filter(requestdata => requestdata.name.toLowerCase().includes(query.toLowerCase()));
      setFilterRequest(filteredData); // Update filtered data only
    } else {
      setFilterRequest(request); // Reset to full list
    }
  };

  useEffect(() => {
    fetchData();
  }, [refresh, sideBarRefresh?.adminMealRequestRefresh]);

  const refreshHandler = () => {
    fetchData();
    setSearchQuery('');
  };

    // use Effect to add keyframes for the pulse animation
    useEffect(() => {
      // Add keyframes via JavaScript when component mounts
      const style = document.createElement('style');
      style.innerHTML = `
        @keyframes pulse {
          0% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.2); opacity: 0.8; }
          100% { transform: scale(1); opacity: 1; }
        }
      `;
      document.head.appendChild(style);
    }, []);

  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          // justifyContent: 'center', // Center horizontally
          // alignItems: 'center', // Center vertically
          height: '100vh', // Full viewport height
        }}
      >
        <ProgressBar />
      </div>
    );
  }

  if (errors) {
    return <div>{errors}</div>;
  }

  return (
    <div>
      <Container>
        <Breadcrumbs
          aria-label="breadcrumb"
          sx={{
        marginBottom: '5px',
      }}
        >
          <Typography sx={{ color: 'text.primary' }}>Admin</Typography>
          <Typography sx={{ color: 'text.primary' }}>Meal</Typography>
          <Typography sx={{ color: 'text.primary' }}>Request</Typography>
        </Breadcrumbs>
      </Container>
      <Container className="bg-white" style={{ padding: '20px' }}>
        
     
        <div style={{
                     display: 'flex', width: '25%', marginBottom: '10px', marginTop: '10px', alignItems: 'center',
                   }}
        >
          <Form.Control
            type="text"
            placeholder="Search by Name......"
            value={searchQuery}
            onChange={handleSearch}
            style={{
                         height: '30px',
                         marginTop: '5px',
                         borderColor: 'green',
                         flexGrow: 1,
                       }}
          />
  
          <ButtonGroup icons dir="ltr" style={{ marginTop: '10px' }}>
            <Button
              variant="outline-secondary"
              title="Refresh"
              size="sm"
              style={{ marginLeft: '10px' }}
              onClick={refreshHandler}
            >
              <span className="lnr lnr-sync" />
            </Button>
          </ButtonGroup>
        
        </div>
    
        <Row>
          {filterRequest.length > 0 ? (
 filterRequest.map((req, index) => (
   <RequestShort 
     key={req.id} 
     index={index} 
     date={req.created_date_time} 
     name={req.name} 
     id={req.id} 
     logo={req.photo}             
   />
 ))
) : (
                 // If search results are empty
  <div style={{
                  textAlign: 'center',
      padding: '50px',
      backgroundColor: '#f8d7da',
      borderRadius: '8px',
      marginTop: '20px',
                  color: '#721c24',
      fontSize: '16px',
                }}
  >
    <div
      style={{
  fontSize: '48px',
  marginBottom: '20px',
  color: '#e63946',
  animation: 'pulse 1.5s infinite ease-in-out',
  display: 'inline-block',
  }}
    >
      <FaExclamationCircle style={{ fontSize: '48px', marginBottom: '20px' }} />
    </div>
    <p>{searchQuery ? 'No results found for your search' : 'No meal requests available'}</p>
  </div>
               )}
        </Row>
        <div
          className=""
          style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
      zIndex: 999, 
      display: 'flex', 
      justifyContent: 'flex-end', 
      alignItems: 'center',

    }}
        >
          {filterRequest.length > 0 && (
            <Pagination>
              <Pagination.Prev
                onClick={() => setCurrentPage(currentPage - 1)}
                disabled={currentPage === 1}
              />
              {pageNumbers.map((number, index) => (number === '...' ? (
                <Pagination.Ellipsis key={number} />
            ) : (
              <Pagination.Item
                key={number}
                active={number === currentPage}
                onClick={() => setCurrentPage(number)}
              >
                {number}
              </Pagination.Item>
            )))}
              <Pagination.Next
                onClick={() => setCurrentPage(currentPage + 1)}
                disabled={currentPage === totalPages}
              />
            </Pagination>
          )}
          
        </div>
      </Container>
    </div>
    
  );
};


export default RequestList;
